// TODO: When IE11 support is killed, revert back to using shadow dom and css properties (example: WEBX-203)

igws-logo {
  .logo__text {
    position: absolute;
    top: 28px;
  }

  &[image='dfx-dark'],
  &[image='dfx-light'] {
    .logo__text {
      left: 64px;
    }
  }

  &[image='ig-bank-dfx-dark'],
  &[image='ig-bank-dfx-light'] {
    .logo__text {
      left: 179px;
    }
  }

  .logo {
    display: block;
    height: 37px;
    width: 44px;
    margin: 10px 0 9px;
    background-image: @logo-new-white;
    background-repeat: no-repeat;

    &.ig-bank-dark,
    &.ig-bank-light {
      width: 162px;
      background-size: contain;
    }
    &.dfx-dark,
    &.dfx-light {
      width: 268px !important;
      background-size: contain;
    }
    &.ig-bank-dfx-dark,
    &.ig-bank-dfx-light {
      width: 356px !important;
      background-size: contain;
    }
    &.rebrand-login-uk {
      background-image: var( --logo-rebrand-login-uk);
    }
    &.ig-new-red {
      background-image: var(--logo-new-red);
    }
    &.ig-rebrand-logo-uk {
      background-image: var(--logo-rebrand-uk);
      height: 52px;
      width: 52px;
    }
    &.ig-red-white-bg {
      background-image: var(--logo-red-white-bg);
      height: 52px;
      width: 52px;
    }
    &.ig-bank-dark {
      background-image: @logo-new-bank-red!important;
    }
    &.ig-bank-light {
      background-image: @logo-new-bank-white!important;
    }
    &.dfx-dark {
      background-image: @logo-new-dfx-red!important;
    }
    &.dfx-light {
      background-image: @logo-new-dfx-white!important;
    }
    &.ig-bank-dfx-dark {
      background-image: @logo-new-dfx-bank-red!important;
    }
    &.ig-bank-dfx-light {
      background-image: @logo-new-dfx-bank-white!important;
    }

    &.ig-prime {
      height: 37px;
      width: 187px;
      background-image: @logo-prime;
      background-size: contain;
    }

    span {
      text-indent: -9999px;
      overflow: hidden;
      display: block;
    }

    .card-view-body & {
      margin: 0;
      height: 24px;
      width: 24px;
    }
  }
}

// This is to support pages that are not dynamic
html:lang(de-CH),
html:lang(fr-CH),
html:lang(en-CH),
html:lang(it-CH) {
  igws-logo .logo {
    width: 162px;
    background-image: @logo-new-bank-white;
    background-size: contain;

    &.ig-new-red {
      background-image: @logo-new-bank-red;
    }

    &.ig-prime {
      height: 37px;
      width: 187px;
      background-image: @logo-prime;
      background-size: contain;
    }
  }
}

// White labels logos
.header-cfd-trader,
.header-guardian-cfd,
.header-goodbody,
.header-fortuneo-derivatives,
.header-hargreaves-lansdown-cfd,
.header-hargreaves-lansdown-spreadBetting,
.header-tradebox-cfd,
.header-prt-cfd,
.header-sharenet-cfd,
.header-commsec {
  igws-logo .logo {
    height: 80px;
    background-position: center;
  }
}

igws-logo .logo {
  .header-cfd-trader & {
    background-image: @logo-cfd-trader;
    width: 90px;
  }
  .header-guardian-cfd & {
    background-image: @logo-gus-cfd;
    width: 194px;
  }
  .header-goodbody & {
    background-image: @logo-gby;
    width: 125px;
  }
  .header-fortuneo-derivatives & {
    background-image: @logo-fdf;
    width: 240px;
  }
  .header-hargreaves-lansdown-spreadBetting &,
  .header-hargreaves-lansdown-cfd & {
    background-image: @logo-hls-hlc;
    width: 170px;
  }
  .header-tradebox-cfd & {
    background-image: @logo-bdi;
    width: 220px;
  }
  .header-prt-cfd & {
    background-image: @logo-prt;
    width: 260px;
  }
  .header-sharenet-cfd & {
    background-image: @logo-sha;
    width: 340px;
  }
  .header-commsec & {
    background-image: @logo-csc;
    width: 232px;
  }
}

@media only screen and (max-width: @medium-breakpoint) {
  igws-logo {
    .logo__text {
      top: 20px;
    }

    &[image='dfx-dark'],
    &[image='dfx-light'] {
      .logo__text {
        left: 46px;
      }
    }

    &[image='ig-bank-dfx-dark'],
    &[image='ig-bank-dfx-light'] {
      .logo__text {
        left: 124px;
      }
    }

    .logo {
      &.ig-bank-dark,
      &.ig-bank-light {
        height: 25px;
        width: 114px !important;
      }
      &.dfx-dark,
      &.dfx-light {
        height: 25px;
        width: 182px !important;
      }
      &.ig-bank-dfx-dark,
      &.ig-bank-dfx-light {
        height: 25px;
        width: 235px !important;
      }
      &.ig-prime {
        height: 20px;
        width: 102px;
      }
    }
  }

  html:lang(de-CH),
  html:lang(fr-CH),
  html:lang(en-CH),
  html:lang(it-CH) {
    igws-logo .logo {
      height: 25px;
      width: 114px;
    }
  }

  .centre-disclaimer {
    igws-logo .logo__text {
      top: -9px;
    }
  }
}

@media only screen and (max-width: 768px) {
  igws-logo {
    .logo__text {
      top: 11px;
    }
  }

  .centre-disclaimer {
    igws-logo .logo__text {
      top: 6px;
    }
  }
}
